import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';

/**
 * AdScriptLoaderService
 *
 * Loads the Google AdSense script (`pagead/js/adsbygoogle.js`) once into the
 * document `<head>` when `environment.ads.enabled` is `true`.  This must run
 * before any `GoogleAdComponent` attempts to push to `window.adsbygoogle`.
 *
 * Wire up via `APP_INITIALIZER` in `app.config.ts`:
 *   {
 *     provide: APP_INITIALIZER,
 *     useFactory: (svc: AdScriptLoaderService) => () => svc.load(),
 *     deps: [AdScriptLoaderService],
 *     multi: true,
 *   }
 */
@Injectable({ providedIn: 'root' })
export class AdScriptLoaderService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly document = inject(DOCUMENT);
  private loaded = false;

  load(): void {
    if (!environment.ads.enabled || !isPlatformBrowser(this.platformId) || this.loaded) {
      return;
    }

    const script = this.document.createElement('script');
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${environment.ads.clientId}`;
    script.crossOrigin = 'anonymous';
    this.document.head.appendChild(script);
    this.loaded = true;
  }
}
